import { Pipe, PipeTransform } from '@angular/core';
import { LOCATIONS } from '../../../ngrx/job-locations';

@Pipe({
  name: 'locationFormatPipe'
})
export class LocationFormatPipe implements PipeTransform {
  transform(location: string): any[] {
    return LOCATIONS[location] ? LOCATIONS[location] : location;
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/location-format.pipe.ts